
import React from "react";
import * as joto from "../api/joto";
import * as jotoTypes from "../api/joto-types";
import * as jotoui from "../joto-ui-api";
import {shallowEqual, useSelector} from "react-redux";

export interface ILikeThisProps {
    path : jotoTypes.ProjectPath
    fnlike?: (projectPath: jotoTypes.ProjectPath, like: boolean) => void
    projectDetailPage?: boolean
}

export interface ILikeThisState {
    like : boolean
}

type StateToILikeThisState = (state : jotoui.JotoUIState) => ILikeThisState;
type ProjectPathToStateToILikeThisState = (p : jotoTypes.ProjectPath) => StateToILikeThisState;

const ILikeThis_mapStateToComponentState : ProjectPathToStateToILikeThisState = (p : jotoTypes.ProjectPath) : StateToILikeThisState => {

    // noinspection UnnecessaryLocalVariableJS
    const fn : StateToILikeThisState = (state : jotoui.JotoUIState) => {
        const projects : jotoTypes.Project[] = joto.projectArrayFromStoreAndPathArray(state.globalProjectList.store, [p]);
        return {
            like : projects && projects[0] && projects[0].like
        }
    };

    return fn;
};


export const ILikeThis : React.FunctionComponent<ILikeThisProps> = (props) => {

    const {like} = useSelector(ILikeThis_mapStateToComponentState(props.path), shallowEqual);
    
    let style = {};
    if(like) {
         style = {
             fill: '#E45B69', // Red
             color: '#E45B69', // Red
         }
    }
    if (props.projectDetailPage){
        //@ts-ignore
        style.width = 40; 
        //@ts-ignore
        style.height = 40; 
    }

    if(props.fnlike) {
        const fn : ((projectPath: jotoTypes.ProjectPath, like: boolean) => void) = props.fnlike;
        return <span>
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlnsXlink="http://www.w3.org/1999/xlink"
                 className={'feather'}
                 style={style} onClick={(e) => {e.preventDefault(); e.stopPropagation(); fn(props.path, !like)}}
            >
                <use xlinkHref="/svg/joto.svg#heart"/>
            </svg>
        </span>;
    } else {
        return <span>
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlnsXlink="http://www.w3.org/1999/xlink"
                 className={'feather'}
                 style={style}>
                <use xlinkHref="/svg/joto.svg#heart"/>
            </svg>
        </span>;
    }
};
